import { sfxCore } from "@/lib/celebrate";

const { audio, out, on } = sfxCore;
const ID = "twohearts";

const tone = (a, t, { from, to = from, dur = 0.15, type = "sine", vol = 0.12 }) => {
  const o = a.createOscillator(), g = a.createGain(), at = a.currentTime + t;
  o.type = type; o.frequency.setValueAtTime(from, at); o.frequency.exponentialRampToValueAtTime(Math.max(20, to), at + dur);
  g.gain.setValueAtTime(0.0001, at); g.gain.exponentialRampToValueAtTime(vol, at + 0.005); g.gain.exponentialRampToValueAtTime(0.0001, at + dur);
  o.connect(g).connect(out(a)); o.start(at); o.stop(at + dur + 0.05);
};
const play = (fn) => { if (!on(ID)) return; const a = audio(); if (a) fn(a); };

const PENTA = [523, 587, 659, 784, 880, 1047, 1175, 1319];
export const thSwitch = () => play((a) => tone(a, 0, { from: 340, to: 520, dur: 0.07, type: "triangle", vol: 0.05 }));
export const thPick = (combo) => play((a) => {
  const f = PENTA[combo % PENTA.length];
  tone(a, 0, { from: f, dur: 0.12, vol: 0.1 }); tone(a, 0.04, { from: f * 2, dur: 0.1, vol: 0.04 });
});
export const thLevel = () => play((a) => [523, 659, 784, 1047, 1319].forEach((f, i) => tone(a, i * 0.09, { from: f, dur: 0.35, type: "triangle", vol: 0.1 })));
export const thCrash = () => play((a) => {
  tone(a, 0, { from: 420, to: 60, dur: 0.5, type: "sawtooth", vol: 0.12 });
  tone(a, 0.05, { from: 200, to: 40, dur: 0.6, type: "square", vol: 0.05 });
});
export const thStart = () => play((a) => [392, 523, 659].forEach((f, i) => tone(a, i * 0.12, { from: f, dur: 0.18, type: "triangle", vol: 0.09 })));
